export default __webpack_public_path__ + "static/media/card8.186af9cf.png";